import { AnyAction } from 'redux';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { STATE } from 'app/constants';
import { ErrorNotification, SuccessNotification } from 'app/infrastructure/notifications/user-messages';
import { isForbiddenStatus, blockAccess } from 'app/area/shared/actions-utils';
import { externalUrlAdminTranslation } from '../constants';
import { defaultMaxResults } from './constants';
import {
  ClearList,
  RequestList, ReceiveList, FailList,
  RequestDeleteExternalUrl, ReceiveDeleteExternalUrl, FailDeleteExternalUrl
} from './action-types';
import { api } from './api';
import { mapList } from './map-list';
import { ExternalUrlsSearchModel } from './types-store';
import { replaceTemplateString } from 'app/infrastructure/platform';

export const actionCreators = {

  clearList: (): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {
      const requestId = Date.now();
      dispatch(new ClearList(requestId));
    },

  loadList: (
    model: ExternalUrlsSearchModel,
    startIndex: number = 0,
    maxResults: number = defaultMaxResults
  ): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {

      const requestId = Date.now();
      dispatch(new RequestList(requestId, model, startIndex === 0));

      try {
        const listResponse = await api.loadList(model, startIndex, maxResults);

        dispatch(new ReceiveList(requestId, mapList(listResponse.results), listResponse.totalNumberOfResults));
      } catch (err) {
        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));

        if (isForbiddenStatus(err)) {
          blockAccess({
            dispatch,
            getState,
            area: STATE.externalUrlAdministration,
            translationId: externalUrlAdminTranslation.no_access_to_external_urls
          });
        }

        dispatch(new FailList(requestId));
      }
    },

  deleteExternalUrl: (id: number, externalUrlText: string, successMessage: string): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      dispatch(new RequestDeleteExternalUrl(id));

      try {

        await api.deleteExternalUrl(id);
        dispatch(new ReceiveDeleteExternalUrl(id));
        dispatch(new SuccessNotification(replaceTemplateString(successMessage, externalUrlText)));

      } catch (err) {

        if (err && (err.userMessages || err.message)) {
          dispatch(new ErrorNotification(err.userMessages || err.message));
        }
        dispatch(new FailDeleteExternalUrl(id));
      }
    },

  displayError: (errorMessage: string): ActionDispatching<any, any> =>
    (dispatch, getState) => {
      dispatch(new ErrorNotification(errorMessage));
    }
};
